<div class="flex-auto">
  <label *ngIf="showLabel" class="block font-semibold mb-2">
    <span class="mr-1">{{ label }}</span>
    <span *ngIf="checkRequire" class="text-danger">*</span>
  </label>
  <textarea
    class="w-full resize-y p-inputtext"
    (blur)="onTouched()"
    [formControl]="control"
    [ngClass]="{ 'ng-invalid ng-dirty': errors, readonly: readonly }"
    [readOnly]="readonly"
    [placeholder]="placeholder"
    [rows]="rows"
  ></textarea>
  <div class="validator-errors">
    <small *ngIf="errors" class="error-msg block fadeinup animation-duration-300">
      <span class="block text-danger">{{ getError().key | translate: getError().required }}</span>
    </small>
  </div>
</div>
